import { render } from "./jhi-footer.vue?vue&type=template&id=7662a689&ts=true"
import script from "./jhi-footer.component.ts?vue&type=script&lang=ts"
export * from "./jhi-footer.component.ts?vue&type=script&lang=ts"

import exportComponent from "/home/haris/IdeaProjects/bloodpressure/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__